import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './horizontal-buttons.component.scss';
var HorizontalButtons = /** @class */ (function (_super) {
    tslib_1.__extends(HorizontalButtons, _super);
    function HorizontalButtons(element) {
        return _super.call(this, element) || this;
    }
    HorizontalButtons.prototype.init = function () { };
    HorizontalButtons.prototype.bindEvents = function () { };
    return HorizontalButtons;
}(Base));
export { HorizontalButtons };



//////////////////
// WEBPACK FOOTER
// ./components/horizontal-buttons/horizontal-buttons.component.ts
// module id = 358
// module chunks = 0